<template>
    <Button type="primary" @click="handleClickExport()">
        <slot></slot>
    </Button>
</template>

<script>
    import {repalceGetParamsByObj} from "../plugin/tool";

    export default {
        name: "ExportButton",
        props: {
            params: {},
            api: {}
        },
        methods: {
            handleClickExport() {
                window.open(`/api/${this.api}?` + repalceGetParamsByObj(this.params))
                //点击了导出按钮
                // window.location.href = window.location.origin + `/api/${this.api}?` + repalceGetParamsByObj(this.params)
            }
        }
    }
</script>

<style scoped>

</style>
